/*
 * @Author: Teemo Ding
 * @Date: 2022-02-15 11:33:19
 * @LastEditTime: 2022-06-24 13:58:37
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/config.tsx
 */

import { CommunicationCategory } from '@/src/types/common/template';
import React from 'react';
import { templateCategoryList } from '../CommunicationTemplateDetail/config';
import css from './css.module.less';

export const breadcrumbData = (gatewayName, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/communicationsList',
    name: getI18n('general.sider.communication'),
  },
  {
    url: '',
    name:
      gatewayName ||
      getI18n('storeCommunicationSetting.list.addCommunicationGateway'),
  },
];

export const columns = (
  deleteAction,
  editAction,
  disableEdit,
  disableDelete,
  { getI18n, key },
) => {
  const templateCategory = templateCategoryList.find(
    (item) => item.key === key,
  );
  const getLabel = (text) => {
    const category = templateCategory?.children?.find(
      (item) => item.value === text,
    );
    return category ? category.label : text;
  };
  return [
    {
      title: getI18n('storeCommunicationSetting.detail.templateCategory'),
      dataIndex: 'category',
      key: 'category',
      default: true,
      minWidth: 320,
      onCell: (_, index) => {
        if (index === 1) {
          return { rowSpan: 2 };
        }
        if (index === 2) {
          return { rowSpan: 0 };
        }
      },
      render: (text) => getLabel(text),
    },
    {
      title: getI18n('storeCommunicationSetting.detail.templateName'),
      dataIndex: 'name',
      key: 'name',
      default: true,
      minWidth: 320,
    },
    {
      title: getI18n(
        'storeCommunicationSetting.detail.templateAvailableLanguage',
      ),
      dataIndex: 'availableLanguages',
      key: 'availableLanguages',
      default: true,
      minWidth: 320,
      render: (text, record) => (
        <div>
          {((text || []).map((item) => item.description) || []).toString()}
        </div>
      ),
    },
    disableDelete && disableEdit
      ? {}
      : {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          dataIndex: 'action',
          key: 'action',
          default: true,
          optional: false,
          className: css.columnClass,
          width: 120,
          align: 'center',
          render: (text, record) => (
            <div className={css.action}>
              {disableDelete ? null : (
                <span
                  className={css.delete}
                  onClick={() => deleteAction(record.uuid)}>
                  {getI18n('general.delete')}
                </span>
              )}
              {disableEdit ? null : (
                <span
                  className={css.edit}
                  onClick={() => editAction(record.uuid)}>
                  {getI18n('general.edit')}
                </span>
              )}
            </div>
          ),
        },
  ];
};

export const communicationChannelColum = ({ getI18n }) => [
  {
    title: getI18n('general.sider.salesChannel'),
    key: 'name',
    dataIndex: 'name',
    default: true,
    minWidth: 384,
  },
  {
    title: getI18n('storeCommunicationSetting.detail.salesChannelType'),
    key: 'channelType',
    dataIndex: 'channelType',
    default: true,
    minWidth: 704,
  },
];

export const orderTypes = [
  CommunicationCategory.OrderStatus,
  CommunicationCategory.PaymentReminder,
  CommunicationCategory.AbandonedShoppingCart,
  CommunicationCategory.RefundStatus,
  CommunicationCategory.ReturnStatus,
  CommunicationCategory.CreateSubscriptionBuyOrder,
  CommunicationCategory.CreateOrder,
  CommunicationCategory.CreateShoppingCart,
];

export const fulfillmentTypes = [
  CommunicationCategory.VirtualProductNotification,
  CommunicationCategory.GiftCardIssued,
  CommunicationCategory.GiftCardBalanceChanged,
  CommunicationCategory.StoreCreditIssued,
  CommunicationCategory.LogisticsStatusUpdate,
];

export const customerTypes = [
  CommunicationCategory.AccountInvitation,
  CommunicationCategory.AccountWelcome,
  CommunicationCategory.AccountPasswordReset,
  CommunicationCategory.VerificationCode,
  CommunicationCategory.CustomerServiceRequest,
];

export const productTypes = [
  CommunicationCategory.RestockItem,
  CommunicationCategory.FlashSaleStart,
];

export const voucherTypes = [
  CommunicationCategory.VoucherIssued,
  CommunicationCategory.VoucherExpiration,
];
